import React from 'react';
import { Row } from 'react-bootstrap';

const breeds = [
    'Australian Cattle Dog',
    'American Pit Bull Terrier',
    'Shih Tzu',
    'German Shepherd',
    'Boxer',
    'Siberian Husky',
    'Labrador Retriever',
];
const percentages = [23.0, 22.5, 13.8, 11.6, 10.9, 9.7, 8.5];
const colors = [
    '#E94033',
    '#377A79',
    '#437FC1',
    '#96C5EA',
    '#87A4A3',
    '#777D83',
    '#D6D9D8',
];
const labelsWithPercentages = breeds.map((breed, index) => ` ${percentages[index]}% - ${breed} `);

// eslint-disable-next-line no-unused-vars
const dataForChart = {
    labels: labelsWithPercentages,
    values: percentages,
    colorBackgrounds: colors,
    colorBorders: colors,
};

const BreedBreakDown = ({ ruleResult }) => {
    return (
        <>


            <Row className="justify-content-center" style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center', height: '600px' }}>
                <div className="heading" style={{
                    position: 'absolute',
                    padding: '20px',
                    borderRadius: '10px',
                    fontWeight: 'bold',
                    textAlign: 'center',
                    top: '20%',
                    left: '51%',
                    transform: 'translate(-50%, -50%)'
                }}>
                    Coming Soon...
                </div>
            </Row>


            {/* <Row style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'center', height: '400px', width: "700px" }}>
                    <DonutChartComponent data={dataForChart} />
                </div>
            </Row> */}
        </>
    );
};

export default BreedBreakDown;
